// extracted by mini-css-extract-plugin
export default {"root":"_1wh0A"};